import React, { useRef } from 'react';
import { ListBase, ListToolbar, useRefresh, Datagrid } from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';

import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import TextoField from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import Actions from './ActionsList';
import DialogoDeletar from './DialogoDeletar';
//import ActionsField from './Fields/ActionsField';
import ValorField from './Fields/ValorField';
import Filter from './Filter';
import {} from '../../utils/dadosTelas';

const useStylesDatagrid = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const DataGridLocal = ({ handleAtivar = () => {}, ...props }) => {
  const classes = useStylesDatagrid();
  return (
    <>
      <Datagrid {...props} bulkActionButtons={false}>
        <TextoField
          source="nome"
          label="Descrição"
          sortable={false}
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
        />
        <ValorField
          source="limite"
          label="Limite"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
        />
        <ActionsField
          source="lalala"
          //handleAtivar={handleAtivar}
          textAlign="right"
          label="Ações"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
          actions={[
            {
              title: 'Restaurar',
              icon: <RefreshIcon />,

              onClick: (record) => handleAtivar(record),
            },
          ]}
        />
      </Datagrid>
    </>
  );
};
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoArquivar = useRef(null);

  const desarquivar = (data) => {
    if (refDialogoArquivar.current) {
      refDialogoArquivar.current.handleOpen(data.id);
    }
  };

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <ListToolbar filters={<Filter />} actions={<Actions />} {...props} />
      <div style={{ borderRadius: '20px', marginTop: '30px', display: 'flex' }}>
        <DataGridLocal handleAtivar={desarquivar} />
      </div>
      <DialogoDeletar
        ref={refDialogoArquivar}
        handleClose={handleClose}
        ativar
      />
    </>
  );
};

const ContainerMyList = ({ ...props }) => (
  <ListBase {...props}>
    <MyList />
  </ListBase>
);

const CategoryList = (props) => (
  <ProtegerPagina permissao="publico">
    <ContainerMyList
      {...props}
      title=""
      component="div"
      bulkActionButtons={false}
      sort={{ field: 'nome', order: 'asc' }}
      perPage={20}
      pagination={false}
    />
  </ProtegerPagina>
);

export default CategoryList;
